import {
    USER_CREATE_REQUEST,
    USER_CREATE_SUCCESS,
    USER_CREATE_FAILURE,
    RESEND_EMAIL_REQUEST,
    RESEND_EMAIL_SUCCESS, RESEND_EMAIL_FAILURE
} from "./constants";

const initialState = {
    addIsSuccess: undefined,
    user: [],
    validation: {
        email: {valid: true, message: ''},
        username: {valid: true, message: ''}
    },
    resendEmailResponse: undefined,
    resendEmailSuccess: false,
};

const registerReducer = (state = initialState, action) => {

    switch (action.type) {
        case USER_CREATE_REQUEST:
            return Object.assign({}, state, {validation: {
                    email: {valid: true, message: ''},
                    username: {valid: true, message: ''}
                }});
        case USER_CREATE_SUCCESS:
            return Object.assign({}, state, {addIsSuccess: true});
        case USER_CREATE_FAILURE:
            const uniqueFields = action.data.error.validationErrors;
            const validation = JSON.parse(JSON.stringify(state.validation));
            for (var i in uniqueFields) {
                let text = (uniqueFields[i] === 'email') ? 'email address' : uniqueFields[i];
                validation[uniqueFields[i]]['valid'] = false;
                validation[uniqueFields[i]]['message'] = 'This '+text+' has been taken. Please try another one.';
            }
            return Object.assign({}, state, { validation, addIsSuccess: false });
        case RESEND_EMAIL_REQUEST:
            return Object.assign({}, state, {resendEmailSuccess: false});
        case RESEND_EMAIL_SUCCESS:
            return Object.assign({}, state, {resendEmailResponse : action.data, resendEmailSuccess: true});
        case RESEND_EMAIL_FAILURE:
            return Object.assign({}, state, {resendEmailResponse : action.data ,resendEmailSuccess: false});
        default:
            return state;
    }
};

export default registerReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Register/reducer.js